import 'vite/modulepreload-polyfill';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import { store } from '@/store';
import App from '@/App';
import { DjangoDataProvider } from '@/contexts/DjangoContext';
import { SentryErrorBoundary } from '@/components/ErrorBoundary';
import { initSentry } from '@/lib/sentry';
import '@/styles/global.scss';

// Initialize Sentry before rendering
initSentry();

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnWindowFocus: false,
      retry: 2,
    },
  },
});

// Get Django data from the template
const getDjangoData = () => {
  const dataElement = document.getElementById('django-data');
  const componentElement = document.getElementById('react-component');
  
  return {
    data: dataElement ? JSON.parse(dataElement.textContent || '{}') : {},
    component: componentElement ? JSON.parse(componentElement.textContent || '"App"') : 'App',
  };
};

// Initialize the application
const { data: djangoData, component: reactComponent } = getDjangoData();

// Store Django data globally for components to access (keep for backward compatibility)
(window as any).__DJANGO_DATA__ = djangoData;
(window as any).__REACT_COMPONENT__ = reactComponent;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <SentryErrorBoundary>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <DjangoDataProvider djangoData={djangoData}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </DjangoDataProvider>
      </QueryClientProvider>
    </Provider>
  </SentryErrorBoundary>
); 